import { render, staticRenderFns } from "./ProjectCustomerTableCell.vue?vue&type=template&id=45b7637a&scoped=true"
import script from "./ProjectCustomerTableCell.vue?vue&type=script&lang=js"
export * from "./ProjectCustomerTableCell.vue?vue&type=script&lang=js"
import style0 from "./ProjectCustomerTableCell.vue?vue&type=style&index=0&id=45b7637a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b7637a",
  null
  
)

export default component.exports